import React from 'react';
import { toast } from 'sonner';
import { Copy, Download, KeyRound } from 'lucide-react';

export const RecoveryCodes = ({ codes, onClose }) => {
  const text = codes.join('\n');
  const download = () => {
    const url = URL.createObjectURL(new Blob([`Códigos de recuperación NotaryOS\nCada código sirve una sola vez.\n\n${text}\n`], { type: 'text/plain' }));
    const a = document.createElement('a');
    a.href = url; a.download = 'codigos_recuperacion_notaryos.txt'; a.click();
    URL.revokeObjectURL(url);
  };
  return (
    <div className="p-4 rounded-xl border border-amber-500/40 bg-amber-500/5 space-y-3" data-testid="recovery-codes-panel">
      <div className="flex items-center gap-2 text-amber-300 font-semibold text-sm"><KeyRound className="w-4 h-4" /> Guarda tus códigos de recuperación</div>
      <p className="text-xs text-slate-400">Úsalos si pierdes tu teléfono o el acceso a tu correo. Cada uno sirve una sola vez y no los volveremos a mostrar.</p>
      <div className="grid grid-cols-2 gap-2 font-mono text-sm" data-testid="recovery-codes-list">
        {codes.map((c) => <span key={c} className="bg-slate-900/60 rounded px-2 py-1 text-center">{c}</span>)}
      </div>
      <div className="flex flex-wrap gap-2">
        <button onClick={() => { navigator.clipboard.writeText(text); toast.success('Copiados'); }} data-testid="recovery-copy-btn" className="text-sm px-3 py-1.5 rounded-lg border border-slate-700 hover:bg-slate-800 flex items-center gap-1.5"><Copy className="w-4 h-4" /> Copiar</button>
        <button onClick={download} data-testid="recovery-download-btn" className="text-sm px-3 py-1.5 rounded-lg border border-slate-700 hover:bg-slate-800 flex items-center gap-1.5"><Download className="w-4 h-4" /> Descargar</button>
        <button onClick={onClose} data-testid="recovery-done-btn" className="text-sm px-3 py-1.5 rounded-lg bg-amber-500/20 text-amber-200 hover:bg-amber-500/30">Ya los guardé</button>
      </div>
    </div>
  );
};
